import { Component, OnInit } from '@angular/core';
import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { DbangService } from 'src/app/services/dbang.service';
import { UtenteService } from 'src/app/services/utente.service';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [MdbCarouselModule]
})
export class HomeComponent implements OnInit {
  isUtenteLogin = true
  constructor(private service:UtenteService, private dbang: DbangService) { }

  ngOnInit(): void {
    /* this.service.isLogin.subscribe(
      (a)=>{this.isUtenteLogin = a as boolean}
    ) */
      /* this.dbang.index().subscribe((data: any) => {
        console.log(data)
      }) */
  }

  info(a:string){
    
  }

}
